export default {
    page_title: "Kevi | Gerenciamento da Base",
    title: "Gerenciamento da Base de Clientes",
    last_step_confirm: "Esta é a última etapa,",
    last_step_irreversible: "essa ação é irreversível!",
    start_deletion_text: "Para iniciar o processo de remoção parcial de sua base de clientes,",
    click_here: "clique aqui",
    step1_title: "1. Fazer Filtro para Deleção de Clientes",
    apply_filters: "Aplicar Filtros",
    step2_title: "2. Confirmar Clientes e Leads a Serem Deletados",
    step3_title: "3. Confirmar e Deletar Clientes",
    col_name: "Nome",
    col_phone: "Telefone",
    col_birthday: "Aniversário",
    col_avg_ticket: "Ticket Médio (R$)",
    col_total_spent: "R$ Gastos",
    col_email: "E-mail",
    birthday_not_set: "Não informada",
    details_button: "Detalhes",
    clients_now: "Clientes agora",
    selected_for_removal: "Selecionados para remoção",
    remaining_after_removal: "Clientes restantes após remoção",
    delete_button_singular: "Deletar {0} cliente",
    delete_button: "Deletar {0} clientes",
    confirm_phrase_placeholder_singular: "Deletar {0} cliente permanentemente",
    confirm_phrase_placeholder_plural: "Deletar {0} clientes permanentemente",
    no_clients: "Você ainda não tem nenhum cliente cadastrado",
    total_stats: {
        title: "Total da Base",
        clients: "Clientes",
        leads: "Leads",
        total: "Total (Clientes + Leads)",
    },
    clients_by_branch: {
        title: "Clientes por Unidade",
        clients_in: "Clientes em {0}",
    },
    deletion_info: {
        irreversible: "Deletar clientes ou leads da base é uma ação irreversível.",
        will_delete: "Junto com os clientes iremos deletar:",
        all_sales: "Todas suas vendas",
        all_tasks: "Todas suas tarefas",
        all_messages: "Todas as mensagens enviadas",
        all_records: "Qualquer registro vinculado a esse cliente",
        permanent: "Essa exclusão é permanente.",
        inconsistency: "Deletar parte dos clientes pode gerar inconsistência nos dados",
        inconsistency_detail: ", a partir do momento que você deleta parte dos seus clientes, talvez os relatórios da Kevi não reflitam mais os mesmos números do seu ERP.",
    },
};
